<template>
  <div class="w-list-block">
    <div v-for="(item, index) in wIds" :key="index">
      <!-- <div v-for="(t, i) in authority" :key="i"> -->
      <div v-if="item == 1" class="capacityBox">
        <InstalledCapacityTitle>智慧用能终端装机规模</InstalledCapacityTitle>
        <el-button v-if="!isCapacityDetailData" class="detailBtn" type="primary" size="mini" @click="capacityDetail()">详情</el-button>
        <ScaleBlock v-if="isCapacity&&!isCapacityDetailData" :capacityData="capacityData"></ScaleBlock>
        <i v-if="isCapacityDetailData" class="el-icon-close" @click="isCapacityDetailData=false"></i>
        <TableData v-if="isCapacityDetailData&&capacityDetailData.length>0" class="capacityTable" :tableHeader="capacityTableHeader" :detailTableData="capacityDetailData" :isPortrait="!isPortrait" :dataType="'capacityData'"></TableData>
      </div>
      <div v-if="item == 2">
        <ListBox class="projectListBox" boxName="projectList">项目列表</ListBox>
        <ProjectList :projectListData="projectList" @changeParams="changeParams($event)" :currStatus="currStatus"></ProjectList>
      </div>
      <div v-if="item == 3">
        <IncomeStatisticsTitle>智慧用能分项收益统计</IncomeStatisticsTitle>
        <el-button v-if="!isIncomeDetailData" class="detailBtn incomeDetail" type="primary" size="mini" @click="incomeDetail()">详情</el-button>
        <WBlock v-if="!isIncomeDetailData">
          <WEchartsPie ref="incomePie" :echartsData="echartsPieData" :totalRevenue="totalRevenue"></WEchartsPie>
        </WBlock>
        <i v-if="isIncomeDetailData" class="el-icon-close incomeClose" @click="incomeCloseBtn()"></i>
        <TableData v-if="isIncomeDetailData" class="incomeTable" :tableHeader="incomeTableHeader" :detailTableData="incomeDetailData" :isPortrait="!isPortrait" :dataType="'incomeData'"></TableData>
      </div>
      <div v-if="item == 4">
        <ListBox class="electricityListBox" boxName="electricityList">电量统计</ListBox>
        <el-button v-if="!isElectricityDetailData" class="detailBtn electricityDetail" type="primary" size="mini" @click="electricityDetail()">详情</el-button>
        <ElectricityStatistics v-if="!isElectricityDetailData" :statisticsData="statisticsData"></ElectricityStatistics>
        <i v-if="isElectricityDetailData" class="el-icon-close electricityClose" @click="electricityDetailCloseBtn()"></i>
        <TableData v-if="isElectricityDetailData" class="electricityTable" :tableHeader="electricityTableHeader" :detailTableData="electricityDetailData" :isPortrait="isPortrait"></TableData>
      </div>
      <!-- </div> -->
    </div>
  </div>
</template>

<script>
  import HOMEAPI from '@/api/svolt/home';
  import {
    getInfo
  } from '@/utils/auth';
  import ListBox from '../../components/list-box';
  import ProjectList from '../../components/project-list';
  import InstalledCapacityTitle from '../../components/installedCapacity-title';
  import IncomeStatisticsTitle from '../../components/incomeStatistics-title';
  import WEchartsPie from '../../components/w-echarts-pie';
  import Block from '../../components/block';
  import WBlock from '../../components/w-block';
  import ElectricityStatistics from '../../components/w-electricity-statistics';
  import ScaleBlock from '../../components/scale-block';
  import SmallBlock from '../../components/small-block';
  import ChargeDischargeStatistics from '../../components/charge-discharge-statistics.vue';
  import EchartsTop5 from '../../components/echarts-top5.vue';
  import EchartsPie from '../../components/echarts-pie.vue';
  import EchartsPagoda from '../../components/echarts-pagoda.vue';
  import EchartsCake from '../../components/echarts-cake.vue';
  import TableData from '../../components/organization-table-data.vue';
  export default {
    name: 'MixChart',
    components: {
      IncomeStatisticsTitle,
      WEchartsPie,
      ScaleBlock,
      Block,
      WBlock,
      ListBox,
      ProjectList,
      ElectricityStatistics,
      InstalledCapacityTitle,
      SmallBlock,
      ChargeDischargeStatistics,
      EchartsTop5,
      EchartsPie,
      EchartsPagoda,
      EchartsCake,
      TableData
    },
    props: {
      wIds: {
        type: [Array],
        default () {
          return [1, 2];
        }
      },
      projectStatus: ''
    },
    data() {
      return {
        intervalTime: null,
        capacityData: {},
        isCapacity: false,
        solarVolume: {
          title: '光伏总容量(MWp)',
          number: '300'
        },
        totalEnergy: {
          title: '累计发电量(MWh)',
          number: '5623'
        },
        todayEnergy: {
          title: '今日发电量(MWh)',
          number: '320'
        },
        projectEnergy: [],
        totalIncome: 0,
        echartsPagodaData: {
          xAxis: [],
          series: []
        },
        chargeDischargeStatisticsData: {
          chargeData1: {
            title: '日充电量',
            number: '1667.2'
          },
          chargeData2: {
            title: '日放电量',
            number: '271.6'
          },
          chargeData3: {
            title: '总充电量',
            number: '1049227.4'
          },
          chargeData4: {
            title: '总放电量',
            number: '836401.4'
          }
        },
        echartsTopData: [],
        energyBlockData: [],
        projectList: [],
        echartsPieData: {
          pieData: []
        },
        statisticsData: [],
        dayChargingStatisticsData: {},
        authority: [], //权限列表
        isCapacityDetailData: false,
        capacityTableHeader: [{
          label: "项目名称",
          prop: "projectName",
          width: "110"
        }, {
          label: "储能",
          prop: "energyStorageCapacity",
          width: "50"
        }, {
          label: "光伏",
          prop: "solarCapacity",
          width: "50"
        }, {
          label: "充电桩",
          prop: "chargingPileCapacity",
          width: "60"
        }],
        capacityDetailData: [],
        isIncomeDetailData: false,
        incomeTableHeader: [{
          label: "项目名称",
          prop: "projectName",
          width: "120"
        }, {
          label: "储能",
          prop: "energyIncome",
          width: "50"
        }, {
          label: "光伏",
          prop: "solarIncome",
          width: "50"
        }, {
          label: "充电桩",
          prop: "chargingPileIncome",
          width: "50"
        }],
        incomeDetailData: [],
        isElectricityDetailData: false,
        electricityTableHeader: [{
          label: "项目名称",
          prop: "projectName",
          width: ""
        }, {
          label: "储能今日充电量",
          prop: "chargingToday",
          width: ""
        }, {
          label: "储能累计充电量",
          prop: "chargingHistory",
          width: ""
        }, {
          label: "储能今日放电量",
          prop: "disChargingToday",
          width: ""
        }, {
          label: "储能累计放电量",
          prop: "disChargingHistory",
          width: ""
        }, {
          label: "光伏今日充电量",
          prop: "solarChargingToday",
          width: ""
        }, {
          label: "光伏累计充电量",
          prop: "solarChargingHistory",
          width: ""
        }, {
          label: "充电桩今日充电量",
          prop: "chargingPileChargingToday",
          width: ""
        }, {
          label: "充电桩累计充电量",
          prop: "chargingPileChargingHistory",
          width: ""
        }],
        electricityDetailData: [],
        isPortrait: true,
        totalRevenue: {},
        currStatus: '',
        filterText: '',
      };
    },
    methods: {
      // 初始数据
      init() {
        let tempAuth = localStorage.getItem('ActiveModule');
        let idsArray = [];
        if (tempAuth) {
          let json = JSON.parse(tempAuth);
          this.authority = [];
          json.item.forEach(item => {
            this.authority.push({
              showOrder: item.showOrder,
              resourceId: item.resourceId,
              resourceNameShow: item.resourceNameShow
            });
            idsArray.push(item.resourceId);
          });
        }
        this.getUserInfo();
        if (this.wIds.includes(1)) {
          this.searchStatisticalCapacityByGroup();            // 智慧用能终端装机规模
        }
        if (this.wIds.includes(3) || this.wIds.includes(4)) {
          this.searchGroupEarningsStatistics();         //智慧用能分项收益统计
          this.searchElectricityStatistics();           //电量统计
        }
      },
      // 获取用户信息
      getUserInfo() {
        let info = getInfo();
        let tp = typeof info;
        if (tp === 'string') {
          this.userInfo = JSON.parse(info);
        }
      },

      // 智慧用能终端装机规模
      async searchStatisticalCapacityByGroup() {
        let self = this;
        let res = await HOMEAPI.searchStatisticalCapacityByGroup();
        if (res.data.code == 200) {
          self.capacityData = res.data.data;
          self.isCapacity = true;
        }
      },
      // 智慧用能终端装机规模-打开详情列表视图
      async capacityDetail() {
        let self = this;
        let res = await HOMEAPI.statisticalCapacityByGroupDetail();
        if (res.data.code == 200) {
          self.capacityDetailData = res.data.data;
          self.isCapacityDetailData = true;
        }
      },

      // 项目列表
      async searchProjectTreeListByGroupId() {
        const params = {
          projectStatus: this.currStatus ? this.currStatus: '',
          projectName: this.filterText ? this.filterText : ''
        };
        let self = this;
        let res = await HOMEAPI.searchProjectTreeListByGroupId(params);
        if (res.data.code == 200) {
          self.projectList = res.data.data;
        }
      },

      // 项目列表-切换项目投运状态、修改项目筛选内容
      changeParams(e) {
        this.currStatus = e[0];
        this.filterText = e[1];
        this.searchProjectTreeListByGroupId();
      },

      // 智慧用能分项收益统计
      async searchGroupEarningsStatistics() {
        let self = this;
        let res = await HOMEAPI.searchGroupEarningsStatistics();
        if (res.data.code == 200) {
          let chargingPileIncome = self.dataProcess(res.data.data.chargingPileIncome);
          let energyIncome = self.dataProcess(res.data.data.energyIncome);
          let solarIncome = self.dataProcess(res.data.data.solarIncome);
          let totalRevenue = Number(res.data.data.chargingPileIncome) + Number(res.data.data.energyIncome) + Number(res.data.data.solarIncome);
          self.totalRevenue = self.dataProcess(String(totalRevenue));
          self.echartsPieData = {
            pieData: [{
              value: chargingPileIncome.value,
              unit: chargingPileIncome.unit,
              name: '充电桩收益',
              label: {
                color: '#F09D3D',
                // fontFamily: 'DIN'
              }
            }, {
              value: energyIncome.value,
              unit: energyIncome.unit,
              name: '储能收益',
              label: {
                color: '#033A7C',
                // fontFamily: 'DIN'
              }
            }, {
              value: solarIncome.value,
              unit: solarIncome.unit,
              name: '光伏收益',
              label: {
                color: '#19CAE4',
                // fontFamily: 'DIN'
              }
            }]
          }
          self.$nextTick(() => {
            self.reflash('incomePie', 'reset');
          })
        }
      },
      dataProcess(data) {
        let value = data;
        let unit = "元";
        if (data.indexOf(".") != -1) {
          let arr = data.split(".");
          if (arr[0].length >= 5) {
            value = (data / 10000).toFixed(2);
            unit = "万元";
          }
        } else {
          if (data.length >= 5) {
            value = (data / 10000).toFixed(2);
            unit = "万元";
          }
        }
        return {
          value: value,
          unit: unit
        };
      },
      // 智慧用能分项收益统计-打开详情列表视图
      async incomeDetail() {
        let self = this;
        let res = await HOMEAPI.groupEarningsStatisticsDetail();
        if (res.data.code == 200) {
          self.incomeDetailData = res.data.data;
          self.isIncomeDetailData = true;
        }
      },
      // 智慧用能分项收益统计-关闭列表视图
      incomeCloseBtn() {
        this.isIncomeDetailData = false;
        this.$nextTick(() => {
          this.reflash('incomePie', 'reset');
        })
      },

      // 电量统计
      async searchElectricityStatistics() {
        let self = this;
        let res = await HOMEAPI.searchElectricityStatistics();
        if (res.data.code == 200) {
          let energyStorageData = {
            id: 'energyStorage',
            name: '储能电量统计',
            todayChargingCapacity: res.data.data.chargingToday.indexOf(".") != -1 ? Number(res.data.data.chargingToday).toFixed(2) : res.data.data.chargingToday,
            todayChargingCapacityUnit: res.data.data.chargingTodayUnit,
            todayChargingCapacityName: '今日充电量',
            todayDischargeCapacity: res.data.data.disChargingToday.indexOf(".") != -1 ? Number(res.data.data.disChargingToday).toFixed(2) : res.data.data.disChargingToday,
            todayDischargeCapacityUnit: res.data.data.disChargingTodayUnit,
            todayDischargeCapacityName: '今日放电量',
            totalChargingCapacity: res.data.data.chargingHistory.indexOf(".") != -1 ? Number(res.data.data.chargingHistory).toFixed(2) : res.data.data.chargingHistory,
            totalChargingCapacityUnit: res.data.data.chargingHistoryUnit,
            totalChargingCapacityName: '累计充电量',
            totalDischargeCapacity: res.data.data.disChargingHistory.indexOf(".") != -1 ? Number(res.data.data.disChargingHistory).toFixed(2) : res.data.data.disChargingHistory,
            totalDischargeCapacityUnit: res.data.data.disChargingHistoryUnit,
            totalDischargeCapacityName: '累计放电量',
          }
          let photovoltaicData = {
            id: 'photovoltaic',
            name: '光伏电量统计',
            todayDischargeCapacity: res.data.data.solarChargingToday.indexOf(".") != -1 ? Number(res.data.data.solarChargingToday).toFixed(2) : res.data.data.solarChargingToday,
            todayDischargeCapacityUnit: res.data.data.solarChargingTodayUnit,
            todayDischargeCapacityName: '今日发电量',
            totalDischargeCapacity: res.data.data.solarChargingHistory.indexOf(".") != -1 ? Number(res.data.data.solarChargingHistory).toFixed(2) : res.data.data.solarChargingHistory,
            totalDischargeCapacityUnit: res.data.data.solarChargingHistoryUnit,
            totalDischargeCapacityName: '累计发电量'
          }
          let chargingPileData = {
            id: 'chargingPile',
            name: '充电桩电量统计',
            todayChargingCapacity: res.data.data.chargingPileChargingToday.indexOf(".") != -1 ? Number(res.data.data.chargingPileChargingToday).toFixed(2) : res.data.data.chargingPileChargingToday,
            todayChargingCapacityUnit: res.data.data.chargingPileChargingTodayUnit,
            todayChargingCapacityName: '今日充电量',
            totalChargingCapacity: res.data.data.chargingPileChargingHistory.indexOf(".") != -1 ? Number(res.data.data.chargingPileChargingHistory).toFixed(2) : res.data.data.chargingPileChargingHistory,
            totalChargingCapacityUnit: res.data.data.chargingPileChargingHistoryUnit,
            totalChargingCapacityName: '累计充电量'
          }
          self.$nextTick(() => {
            self.statisticsData = [energyStorageData, photovoltaicData, chargingPileData];
          })
        }
      },
      // 电量统计-打开详情列表
      async electricityDetail() {
        let self = this;
        let res = await HOMEAPI.electricityStatisticsDetail();
        if (res.data.code == 200) {
          self.electricityDetailData = res.data.data;
          self.isElectricityDetailData = true;
        }
      },
      // 电量统计-关闭列表视图
      electricityDetailCloseBtn() {
        this.isElectricityDetailData = false;
      },

      // 刷新控件
      reflash(arg, func) {
        switch (func) {
          case 'reset': {
            if (this.$refs[arg] && this.$refs[arg].length>0) {
              this.$refs[arg][0].reset();
            }
            break;
          }
          case 'load': {
            if (this.$refs[arg] && this.$refs[arg].length>0) {
              this.$refs[arg][0].load();
            }
            break;
          }
          case 'init': {
            if (this.$refs[arg] && this.$refs[arg].length>0) {
              this.$refs[arg][0].init();
            }
            break;
          }
          case 'loadData': {
            if (this.$refs[arg] && this.$refs[arg].length>0) {
              this.$refs[arg][0].loadData();
            }
            break;
          }
        }
      },

      // 获取充放电量统计
      async searchChargeAndDischargeStatistics() {
        let params = {
          groupId: this.userInfo.groupId
        };
        let res = await HOMEAPI.searchChargeAndDischargeStatistics(params);
        if (res.data.code == 200) {
          let result = res.data.data;
          this.chargeDischargeStatisticsData.chargeData1.number = result['dailyCharge'] || 0;
          this.chargeDischargeStatisticsData.chargeData2.number = result['dailyDisCharge'] || 0;
          this.chargeDischargeStatisticsData.chargeData3.number = result['totalCharge'] || 0;
          this.chargeDischargeStatisticsData.chargeData4.number = result['totalDischarge'] || 0;
        }
      },
      // 储能安全运行天数统计（5天）
      async searchEnergyStorageSafeOperationDays() {
        let self = this;
        let params = {
          groupId: this.userInfo.groupId
        };
        let res = await HOMEAPI.searchEnergyStorageSafeOperationDays(params);
        if (res.data.code == 200) {
          self.echartsTopData = res.data.data;
          self.echartsTopData.map((item, index) => {
            item.id = ++index;
            item.value = parseInt(item.value);
          });
          self.reflash('top5', 'reset');
        }
      },
      // 获取日充放电量
      async searchEnergyStorageChargeAndDischargeColumnChart() {
        let self = this;
        let params = {
          groupId: this.userInfo.groupId
        };
        let res = await HOMEAPI.searchEnergyStorageChargeAndDischargeColumnChart(params);
        if (res.data.code == 200) {
          self.dayChargingStatisticsData = res.data.data;
          self.reflash('dayPie', 'reset');
        }
      },
      // 收益统计
      async searchEnergyStorageIncomeStatisticsColumnChart() {
        var self = this;
        let params = {
          groupId: this.userInfo.groupId
        };
        let res = await HOMEAPI.searchEnergyStorageIncomeStatisticsColumnChart(params);
        if (res.data.code == 200) {
          self.totalIncome = res.data.data.income;
          if (res.data.data.incomeChart) {
            self.echartsPagodaData.xAxis = res.data.data.incomeChart.timestamps;
            self.echartsPagodaData.series = res.data.data.incomeChart.data;
            self.reflash('income', 'load');
          }
        }
      },
      // 储能总容量-投运总容量
      async searchEnergyStorageCommissioningAndEnergyStorageVolume() {
        let params = {
          groupId: this.userInfo.groupId
        };
        let res = await HOMEAPI.searchEnergyStorageCommissioningAndEnergyStorageVolume(params);
        let result = {};
        var energyArr = res.data.data.energyVolume.split("/");
        var commissioningArr = res.data.data.commissioningVolume.split("/");
        if (energyArr[1].length > 5) {
          energyArr[0] = (energyArr[0] / 1000).toFixed(2);
          energyArr[1] = (energyArr[1] / 1000).toFixed(2);
          commissioningArr[0] = (commissioningArr[0] / 1000).toFixed(2);
          commissioningArr[1] = (commissioningArr[1] / 1000).toFixed(2);
          result = {
            commissioningVolume: commissioningArr[0] + "/" + commissioningArr[1],
            energyVolume: energyArr[0] + "/" + energyArr[1]
          };
          for (let i in this.energyBlockData) {
            this.energyBlockData[i].unit = "(MW/MWh)"
          }
        } else {
          result = res.data.data;
        }
        if (res.data.code == 200) {
          this.energyBlockData.map(item => {
            item.data = result[item.key];
          });
        }
      },
      // 光伏统计
      async searchSolarStatistics() {
        let self = this;
        let params = {
          groupId: this.userInfo.groupId
        };
        let res = await HOMEAPI.searchSolarStatistics(params);
        if (res.data.code == 200) {
          this.solarVolume.number = res.data.data.solarVolume;
          this.todayEnergy.number = res.data.data.todayEnergy;
          this.totalEnergy.number = res.data.data.totalEnergy;
          this.projectEnergy = res.data.data.projectEnergy;
          self.reflash('gf', 'loadData');
        }
      }
    },
    created() {
      this.init();
      if (this.wIds.includes(2)) {
        this.searchProjectTreeListByGroupId();        // 项目列表
      }
    },
    mounted() {
      if (this.projectStatus != undefined) {
        this.intervalTime = setInterval(() => {
          this.init();
        }, 10000);
      }
    },
    beforeDestroy() {
      clearInterval(this.intervalTime);
    }
  };
</script>

<style lang="scss" scoped>
  .w-list-block {
    width: 100%;
    height: 100%;
    position: absolute;

    .s-row {
      display: flex;
      justify-content: space-between;
      width: 100%;
    }

    .income-data {
      display: inline-block;
      position: absolute;
      top: 10px;
      right: 10px;

      .income-title {
        height: 16px;
        font-size: 14px;
        font-family: PingFangSC-Semibold, PingFang SC;
        font-weight: 600;
        color: #71daf9;
        line-height: 16px;
        text-align: right;
      }

      .income-number {
        font-size: 28px;
        font-family: DINBold, DINAlternate;
        font-weight: bold;
        color: #71dfff;
        margin-top: 4px;
      }
    }

    .pagoda-wrap {
      height: 173px;
    }

    .bottom10 {
      margin-bottom: 10px;
    }

    .s-block {
      width: 64px !important;
    }

    .echarts-line-wrap {
      height: 154px;
      margin-top: 5px;
    }

    .down-block-wrap {
      margin-top: 0px;
      display: flex;
    }

    .shidian {
      height: 230px;
      margin-top: 5px;
    }

    .zongrongliang {
      height: 173px;
      margin-top: 10px;
    }

    .nenghao {
      margin-top: 10px;
      position: relative;
    }

    .guangfu-home {
      height: 180px;
    }

    .shouyi {
      position: relative;
      height: 37px;
    }

    .capacityBox {
      height: 36.5vh;
    }

    .projectListBox {
      margin-top: 5px;
    }

    .electricityListBox {
      left: 30px;
      width: 390px;
      height: 70vh;
    }

    .detailBtn {
      right: 0px;
      position: absolute;
      z-index: 999;
    }

    .detailBtn.el-button--mini,
    .detailBtn.el-button--mini.is-round {
      border-radius: 8px 0 !important;
      font-size: 12px;
      transform: scale(0.8);
      padding: 3px 8px;
    }

    .incomeDetail {
      margin-top: 5px;
    }

    .electricityDetail {
      margin-top: 35px;
    }

    .capacityTable {
      width: 355px;
      height: 31vh;
      margin-top: 15px;
    }

    .incomeTable {
      width: 370px;
      height: 17vh;
      margin-left: 40px;
      margin-top: 10px;
      z-index: 999;
    }

    .electricityTable {
      width: 370px;
      margin-left: 40px;
      top: 27vh;
      position: absolute;
      z-index: 999;
    }

    .el-icon-close {
      margin-top: 40px;
      right: 10px;
      position: absolute;
      z-index: 999;

      &:hover {
        cursor: pointer;
      }
    }

    .el-icon-close:before {
      color: #528EEA;
      font-size: 16px;
      font-weight: 600;
    }

    .incomeClose {
      margin-top: 22px;
      right: 0px;
    }

    .electricityClose {
      right: 0px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/svolt/home/components/w-list-block.vue